import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrltlFuelSurchargeProfileList extends Layout {
    layoutheaderFSProfileList: LayoutHeader;
    sourceCustomerFuel: DataSource;
    tableFuelSurchargeProfile: Table;
}
